import { render, staticRenderFns } from "./signConfig.vue?vue&type=template&id=9d4cbe28&scoped=true"
import script from "./signConfig.vue?vue&type=script&lang=js"
export * from "./signConfig.vue?vue&type=script&lang=js"
import style0 from "./signConfig.vue?vue&type=style&index=0&id=9d4cbe28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_30effc9705e4bf7ead9172d765b7e483/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4cbe28",
  null
  
)

export default component.exports